// Relative Zeitangaben für Meldungen (Geräte und Rollen, Kundenwunsch 27.10.2026): „gerade eben“, „vor 4 Min.“,
// „vor 3 Std.“ (unter 6 Stunden), „heute 06:13“, „gestern 17:32“, „vor 12 Tagen“ (unter 60 Tagen), sonst das Datum.
// Werte: ISO mit Zeitzone (UTC der Schnittstelle, z. B. Upload) oder Ortszeit-Text ohne Zone (Verkaufszeit des Geräts);
// moment liest beides richtig als lokale Zeit. Zeiten in der Zukunft (Uhr des Geräts geht vor) gelten als „gerade eben“.
import moment from 'moment';

export function relativeTime(value, now = new Date()) {
  if (!value) {
    return '';
  }
  const m = moment(value);
  if (!m.isValid()) {
    return '';
  }
  const minutes = moment(now).diff(m, 'minutes');
  if (minutes < 1) {
    return 'gerade eben';
  }
  if (minutes < 60) {
    return 'vor ' + minutes + ' Min.';
  }
  if (minutes < 360) {
    return 'vor ' + Math.floor(minutes / 60) + ' Std.';
  }
  const today = moment(now).startOf('day');
  if (!m.isBefore(today)) {
    return 'heute ' + m.format('HH:mm');
  }
  if (!m.isBefore(today.clone().subtract(1, 'day'))) {
    return 'gestern ' + m.format('HH:mm');
  }
  const days = today.diff(m.clone().startOf('day'), 'days');
  return days < 60 ? 'vor ' + days + ' Tagen' : m.format('DD.MM.YYYY');
}

export function exactTime(value) {
  if (!value) {
    return '';
  }
  const m = moment(value);
  return m.isValid() ? m.format('DD.MM.YYYY HH:mm:ss') : '';
}

// Alter einer Meldung als Stufe: 'fresh' (unter 24 Stunden), 'stale' (bis 7 Tage), 'old' (älter), 'never' (keine)
export function ageLevel(value, now = new Date()) {
  if (!value) {
    return 'never';
  }
  const m = moment(value);
  if (!m.isValid()) {
    return 'never';
  }
  const hours = moment(now).diff(m, 'hours', true);
  return hours < 24 ? 'fresh' : hours < 24 * 7 ? 'stale' : 'old';
}
